import { render, staticRenderFns } from "./glassSizeOrderedPopover.vue?vue&type=template&id=35ee6f98&scoped=true&"
import script from "./glassSizeOrderedPopover.vue?vue&type=script&lang=js&"
export * from "./glassSizeOrderedPopover.vue?vue&type=script&lang=js&"
import style0 from "./glassSizeOrderedPopover.vue?vue&type=style&index=0&id=35ee6f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee6f98",
  null
  
)

export default component.exports